<template>
  <div class="pd-b-20 mg-x-less">
    <!-- <b-loading :active.sync="isLoadingPage"></b-loading> -->
    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage">
        <div class="initial-load-animation">
          <div class="linkedin-image"></div>
          <div class="loading-bar">
            <div class="blue-bar"></div>
          </div>
        </div>
      </div>
    </transition>

    <div class="level is-marginless is-hidden-mobile">
      <div class="level-left">
        <p
          class="title pd-x-15 is-size-4-tablet is-size-5-mobile has-text-weight-normal"
        >
          {{ $t("dashboard.mainDashboard") }}
        </p>
      </div>
      <div
        class="level-right"
        v-if="getRule == 'board' || getRule == 'exclusiveboard'"
      >
        <!-- <router-link to="/department-admin-list" class="box-back-page is-flex is-align-center">
          <p class="text-back-page backpage-color has-text-weight-semibold">
            <i class="fas fa-arrow-left is-margin-right-sm"></i>Back to Admin
          </p>
        </router-link> -->
      </div>
    </div>
    <div
      v-if="getRule === 'admin' && dashBoardrule === ''"
      class="columns m-h-auto is-marginless pd-x-10"
    >
      <div class="title-link">
        <p class="has-text-secondary has-text-weight-normal">
          <i class="fas fa-link"></i> {{ $t("dashboard.staffLink") }}
        </p>
      </div>
      <div class="column is-5">
        <input
          class="input has-border-secondary"
          type="text"
          v-model="staffLink"
          id="staff-link"
          readonly
        />
      </div>
      <div class="column is-1 has-text-centered-mobile mg-mobile-link">
        <button
          class="button h-100 has-bg-secondary has-text-white"
          @click="copyStaffLink"
        >
          {{ $t("dashboard.btnCopyLink") }}
        </button>
      </div>
    </div>
    <div
      v-if="
        getRule === 'admin' &&
        dashBoardrule === '' &&
        batch.batchClose === false
      "
      class="columns m-h-auto is-marginless pd-x-10"
    >
      <div class="title-link">
        <p class="has-text-primary-green has-text-weight-normal">
          <i class="fas fa-link"></i> {{ $t("dashboard.companyLink") }}
        </p>
      </div>
      <div class="column is-5">
        <input
          class="input has-border-primary"
          type="text"
          v-model="startupLink"
          id="startup-link"
          readonly
        />
      </div>
      <div class="column is-1 has-text-centered-mobile mg-mobile-link">
        <button
          class="button h-100 has-bg-primary has-text-white"
          @click="copyStartupLink"
        >
          {{ $t("dashboard.btnCopyLink") }}
        </button>
      </div>
    </div>
    <div class="columns m-h-auto mg-t-5">
      <div class="column th has-text-right is-size-7 pd-y-0">
        {{ $t("message.updatedOn") }} {{ new Date() | formatDate }}
        <span
          class="dashboard"
          v-if="
            dashBoardrule == '' &&
            getRule != 'exclusiveboard' &&
            getRule != 'board'
          "
        >
          <span class="border-dropdown dashboard-startup">
            <b-dropdown position="is-bottom-left">
              <button class="button dp-btn-noBg mg-r-15 mg-l-10" slot="trigger">
                <template>
                  <i class="fas fa-cogs has-text-grey-light text-name-user"></i>
                </template>
              </button>
              <b-dropdown-item
                @click="$store.commit('setResetDashboard', true)"
                class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
                has-link
              >
                <a class="dp-link has-text-centered"
                  ><i class="fas fa-redo mg-r-8"></i>
                  {{ $t("message.btnResetLayout") }}</a
                >
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
      </div>
    </div>
    <grid-layout
      :layout.sync="layout"
      :col-num="12"
      :row-height="100"
      :is-draggable="
        dashBoardrule !== ''
          ? false
          : getRule !== 'exclusiveboard' && widthMax > 768
          ? true
          : false
      "
      :is-resizable="
        getRule !== 'exclusiveboard' && widthMax > 768 ? true : false
      "
      :is-mirrored="false"
      :vertical-compact="true"
      :margin="[10, 10]"
      :use-css-transforms="true"
    >
      <div v-if="isLoadingPage === false">
        <grid-item
          v-for="item in layout"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
          :minW="item.minW"
          :minH="item.minH"
          drag-allow-from=".vue-draggable-handle"
          drag-ignore-from=".no-drag"
          @moved="updateItemLayout"
          @resized="updateItemLayout"
        >
          <ProjectOverview
            v-show="item.i === '0'"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
          />
          <LevelOfBusiness
            v-show="item.i === '1'"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
          />
          <TypeOfBusiness
            v-show="item.i === '2'"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
          />
          <Performance
            v-show="item.i === '3'"
            @openModalInfo="openModalInfo"
            @openIsDetailWorkToday="openIsDetailWorkToday"
            @openIsDetailWorkTodaySuccess="openIsDetailWorkTodaySuccess"
            :handle="getRule === 'startup' ? true : false"
            :useBy="getRule"
            :tasksAllStartup="tasksAllStartup"
          />
          <PerformanceSupport
            v-show="item.i === '4'"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
            :useBy="getRule"
            :activitysAllStartup="activitysAllStartup"
          />
          <!-- <Investment 
                  v-show="item.i === '5' && getRule !== 'exclusiveboard'" 
                  @openModalInfo="openModalInfo" 
                  :handle="(getRule === 'startup')?true:false"
                  useBy="getRule"
                  :tasksAllStartup="tasksAllStartup"/> -->
          <InvestmentSupport
            v-show="item.i === '6'"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
            :useBy="getRule"
            :showCompany="true"
            :activitysAllStartup="activitysAllStartup"
            :tasksAllStartup="tasksAllStartup"
          />
          <BusinessGrowth
            v-show="item.i === '7'"
            :kpi="kpiAllData"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
            :renderKpi="renderKpi"
            @changTap="changTap"
          />
        </grid-item>
      </div>
    </grid-layout>

    <b-modal
      :active.sync="isDetailWorkToday"
      :width="800"
      @close="closeModalActive(false)"
    >
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <p
              class="is-size-4 has-text-weight-normal has-text-left th is-marginless"
            >
              Task ที่ต้องเริ่มดำเนินงาน
            </p>
            <hr class="mg-y-15" />
            <div class="pd-y-5">
              <p class="th is-size-5 has-text-weight-normal">
                Task ที่เริ่มทำวันนี้
              </p>
              <div v-if="taskDoingToday.length > 0">
                <div v-for="(item, index) in taskDoingToday" :key="index">
                  <p class="pd-l-10 th has-text-weight-normal is-size-6">
                    {{ item.company }}
                  </p>
                  <div v-for="(sub, index) in item.task" :key="index">
                    <p class="pd-l-20 th">{{ index + 1 }}. {{ sub }}</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="pd-l-10 th has-text-left is-size-6">
                  *** ไม่มีกิจกรรม ***
                </p>
              </div>
            </div>
            <div class="pd-y-5">
              <p class="th is-size-5 has-text-weight-normal">
                Task ที่ใกล้ถึงในอนาคต
              </p>
              <div v-if="taskDoingTodayFuture.length > 0">
                <div v-for="(item, index) in taskDoingTodayFuture" :key="index">
                  <p class="pd-l-10 th has-text-weight-normal is-size-6">
                    {{ item.company }}
                  </p>
                  <div v-for="(sub, index) in item.task" :key="index">
                    <p class="pd-l-20 th">{{ index + 1 }}. {{ sub }}</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="pd-l-10 th has-text-left is-size-6">
                  *** ไม่มีกิจกรรม ***
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      :active.sync="isDetailWorkTodaySuccess"
      :width="800"
      @close="closeModalActive(false)"
    >
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <p
              class="is-size-4 has-text-weight-normal has-text-left th is-marginless"
            >
              Task ที่ต้องดำเนินงานเสร็จ
            </p>
            <hr class="mg-y-15" />
            <div class="pd-y-5">
              <p class="th is-size-5 has-text-weight-normal">
                Task ที่ต้องทำเสร็จวันนี้
              </p>
              <div v-if="taskDoingTodaySuccess.length > 0">
                <div
                  v-for="(item, index) in taskDoingTodaySuccess"
                  :key="index"
                >
                  <p class="pd-l-10 th has-text-weight-normal is-size-6">
                    {{ item.company }}
                  </p>
                  <div v-for="(sub, index) in item.task" :key="index">
                    <p class="pd-l-20 th">{{ index + 1 }}. {{ sub }}</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="pd-l-10 th has-text-left is-size-6">
                  *** ไม่มีกิจกรรม ***
                </p>
              </div>
            </div>
            <div class="pd-y-5">
              <p class="th is-size-5 has-text-weight-normal">Task ที่ล่าช้า</p>
              <div v-if="taskDoingPastSuccess.length > 0">
                <div v-for="(item, index) in taskDoingPastSuccess" :key="index">
                  <p class="pd-l-10 th has-text-weight-normal is-size-6">
                    {{ item.company }}
                  </p>
                  <div v-for="(sub, index) in item.task" :key="index">
                    <p class="pd-l-20 th">{{ index + 1 }}. {{ sub }}</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="pd-l-10 th has-text-left is-size-6">
                  *** ไม่มีกิจกรรม ***
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      :active.sync="isInfoMoal"
      :width="800"
      @close="closeModalActive(false)"
    >
      <infomodal :id="infoState" />
    </b-modal>
  </div>
</template>

<script>
import { HTTP, HTTPDynamic } from "../axios.js";
import Doughnut from "../charts/Doughnut";
import BarCharts from "../charts/BarCharts";
import HorizontalBar from "../charts/HorizontalBar";
import LineChart from "../charts/LineChart";
import VueGridLayout from "vue-grid-layout";
import ProductInformation from "./dashboard/ProductInformation.vue";
import PerformanceSupport from "./dashboard/PerformanceSupport.vue";
import Investment from "./dashboard/Investment.vue";
import InvestmentSupport from "./dashboard/InvestmentSupport.vue";
import Performance from "./dashboard/Performance.vue";
import BusinessGrowth from "./dashboard/BusinessGrowth.vue";
import LevelOfBusiness from "./dashboard/LevelOfBusiness.vue";
import ProjectOverview from "./dashboard/ProjectOverview.vue";
import TypeOfBusiness from "./dashboard/TypeOfBusiness.vue";
import infomodal from "./infomodal";

export default {
  props: {
    dashBoardrule: {
      type: String,
      default: "",
    },
  },
  components: {
    Doughnut,
    BarCharts,
    HorizontalBar,
    LineChart,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    ProductInformation,
    PerformanceSupport,
    Investment,
    InvestmentSupport,
    Performance,
    BusinessGrowth,
    LevelOfBusiness,
    ProjectOverview,
    TypeOfBusiness,
    infomodal,
  },
  computed: {
    resetDashboard() {
      return this.$store.state.resetDashboard;
    },
    taskLeft() {
      return this.taskPlan + this.taskInprocess + this.taskOverdue;
    },
    report() {
      return this.$store.state.report;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
    user() {
      return this.$store.state.user;
    },
    startupLists() {
      return this.$store.getters.startupLists;
    },
    batch() {
      return this.$store.state.batch;
    },
    categories() {
      return this.$store.state.categories;
    },
    businessType() {
      return this.$store.state.businessType;
    },
    levelOfBusinessList() {
      let res = [];
      if (this.batch.levelType === 1) {
        res = this.$store.state.projectLevel;
      } else if (this.batch.levelType === 2) {
        res = this.$store.state.businessLevel;
      } else {
        res = this.$store.state.technologyLevel;
      }
      return res;
    },
    businessLevelBarX() {
      let labelX = [];
      if (this.batch.levelType === 1) {
        for (
          let index = 1;
          index <= this.$store.state.projectLevel.length;
          index++
        ) {
          labelX.push("LV." + index);
        }
      } else if (this.batch.levelType === 2) {
        for (
          let index = 1;
          index <= this.$store.state.businessLevel.length;
          index++
        ) {
          labelX.push("LV." + index);
        }
      } else {
        for (
          let index = 1;
          index <= this.$store.state.technologyLevel.length;
          index++
        ) {
          labelX.push("LV." + index);
        }
      }

      return labelX;
    },
    businessLevelBarData() {
      let data = [];
      this.$store.state.businessLevel.map((item) => {
        let filter = this.$store.getters.startupLists.filter(
          (startup) => startup.levelOfbusiness === item.id
        );
        data.push(filter.length);
      });
      //console.log('data',data)
      return data;
    },
    businessTypeBarX() {
      let labelX = [];
      for (
        let index = 0;
        index < this.$store.state.businessType.length;
        index++
      ) {
        let filter = this.$store.getters.startupLists.filter(
          (startup) =>
            startup.typeOfBusiness === this.$store.state.businessType[index].id
        );

        if (filter.length > 0) {
          labelX.push(this.$store.state.businessType[index].name);
        }
        this.heightChart = index * 35;
      }

      return labelX;
    },
    businessTypeBarData() {
      let data = [];
      this.$store.state.businessType.map((item) => {
        let filter = this.$store.getters.startupLists.filter(
          (startup) => startup.typeOfBusiness === item.id
        );
        if (filter.length > 0) {
          data.push(filter.length);
        }
      });

      return data;
    },
    taskApproveAmount() {
      let amount = 0;
      this.tasksAllStartup.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus === 5
        ) {
          amount = amount + item.approveAmount;
        }
      });
      this.renderChart = true;
      return amount;
    },
    taskPendingRequest() {
      let amount = 0;
      this.tasksAllStartup.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus === 2
        ) {
          amount = amount + item.fundAmount;
        }
      });
      return amount;
    },
    taskDone() {
      let filter = this.tasksAllStartup.filter(
        (item) =>
          item.finishProcessDate !== "" &&
          item.finishProcessDate !== null &&
          typeof item.finishProcessDate !== "undefined" &&
          item.fundStatus != 4
      );
      return filter.length;
    },
    taskOverdue() {
      let filter = this.tasksAllStartup.filter(
        (item) =>
          item.status === 4 &&
          (item.finishProcessDate === "" ||
            item.finishProcessDate === null ||
            typeof item.finishProcessDate === "undefined") &&
          item.fundStatus != 4
      );
      return filter.length;
    },
    taskInprocess() {
      let filter = this.tasksAllStartup.filter(
        (item) => item.status === 2 && item.fundStatus != 4
      );
      return filter.length;
    },
    taskPlan() {
      let filter = this.tasksAllStartup.filter(
        (item) => item.status === 1 && item.fundStatus != 4
      );
      return filter.length;
    },
    taskDoingToday() {
      let filter = this.tasksAllStartup.filter(
        (item) =>
          new Date(item.startDate).toLocaleDateString() ===
          new Date().toLocaleDateString()
      );

      let companyToday = [];
      let taskToday = [];

      this.$store.getters.startupLists.map((company) => {
        filter.map((item) => {
          if (item.ownedBy === company.startUpId) {
            taskToday.push(item.name);
          }
        });
        if (taskToday.length !== 0) {
          companyToday.push({ company: company.organizeName, task: taskToday });
          taskToday = [];
        }
      });

      return companyToday;
    },
    taskDoingTodayFuture() {
      let now = new Date().setHours(0, 0, 0, 0);
      let future = new Date().setHours(0, 0, 0, 0) + 86400000 * 7;
      let filter = this.tasksAllStartup.filter(
        (item) =>
          new Date(item.startDate).getTime() > new Date(now).getTime() &&
          new Date(item.startDate).getTime() <= new Date(future).getTime()
      );

      let companyToday = [];
      let taskToday = [];

      this.$store.getters.startupLists.map((company) => {
        filter.map((item) => {
          if (item.ownedBy === company.startUpId) {
            taskToday.push(item.name);
          }
        });
        if (taskToday.length !== 0) {
          companyToday.push({ company: company.organizeName, task: taskToday });
          taskToday = [];
        }
      });

      return companyToday;
    },
    taskDoingTodaySuccess() {
      let filter = this.tasksAllStartup.filter(
        (item) =>
          new Date(item.endDate).toLocaleDateString() ===
          new Date().toLocaleDateString()
      );

      let companyToday = [];
      let taskToday = [];

      this.$store.getters.startupLists.map((company) => {
        filter.map((item) => {
          if (item.ownedBy === company.startUpId) {
            taskToday.push(item.name);
          }
        });
        if (taskToday.length !== 0) {
          companyToday.push({ company: company.organizeName, task: taskToday });
          taskToday = [];
        }
      });

      return companyToday;
    },
    taskDoingPastSuccess() {
      let filter = this.tasksAllStartup.filter(
        (item) =>
          new Date().setHours(0, 0, 0, 0) > new Date(item.endDate).getTime() &&
          item.status !== 3
      );

      let companyToday = [];
      let taskToday = [];

      this.$store.getters.startupLists.map((company) => {
        filter.map((item) => {
          if (item.ownedBy === company.startUpId) {
            taskToday.push(item.name);
          }
        });
        if (taskToday.length !== 0) {
          companyToday.push({ company: company.organizeName, task: taskToday });
          taskToday = [];
        }
      });

      return companyToday;
    },
    tasksAll() {
      if (this.getRule === "startup") {
        let filter = this.$store.getters.tasks.filter(
          (item) => item.fundStatus !== 4
        );
        return filter;
      } else {
        let task =
          typeof this.tasksAllStartup !== "undefined"
            ? this.tasksAllStartup
            : [];
        let filter = task.filter((item) => item.fundStatus !== 4);
        return filter;
      }
    },
    token() {
      return this.$store.state.token;
    },
    staffDetail() {
      return this.$store.state.staffDetail;
    },
    levelType() {
      let filter = this.$store.state.levelType.filter(
        (item) => item.id === this.batch.levelType
      );
      let res = "";
      if (filter.length !== 0) {
        res = filter[0].name;
      } else {
        res = [];
      }
      return res;
    },
    kpiAllData() {
      let kpi = {};
      if (Object.keys(this.kpiAll).length > 0) {
        Object.keys(this.kpiAll[this.kpiAll.length - 1]).forEach((key) => {
          kpi[key] = {
            name: this.kpiAll[0][key].name,
            label: this.kpiAll[0][key].label,
            value: [],
            percent: 0,
          };
          for (let index = 0; index < this.kpiAll.length; index++) {
            for (let x = 0; x < this.kpiAll[index][key].value.length; x++) {
              let old = 0;
              if (kpi[key].value.length > 0) {
                old =
                  typeof kpi[key].value[x] !== "undefined"
                    ? kpi[key].value[x]
                    : 0;
              }
              let sum = Number(this.kpiAll[index][key].value[x]) + Number(old);
              kpi[key].value[x] = sum;
            }
            kpi[key].percent = this.getPercentGrowth(
              kpi[key].value[kpi[key].value.length - 1],
              kpi[key].value[kpi[key].value.length - 2]
            );
          }
        });
        return kpi;
      } else {
        return {};
      }
    },
    categories() {
      return this.$store.state.categories;
    },
    businessType() {
      let data = [];
      this.$store.state.businessType.map((item) => {
        let filter = this.$store.getters.startupLists.filter(
          (startup) => startup.typeOfBusiness === item.id
        );
        if (filter.length > 0) {
          data.push(filter.length);
        }
      });

      return data;
    },
  },
  data() {
    return {
      activitysAll: [],
      renderChart: false,
      heightChart: 0,
      widthMax: window.innerWidth,
      isLoadingPage: null,
      activitysAllStartup: [],
      tasksAllStartup: [],
      isDetailWorkToday: false,
      isDetailWorkTodaySuccess: false,
      staffLink: null,
      startupLink: null,
      isSpa: null,
      kpi: {},
      activeTab: 1,
      renderKpi: true,
      kpiAll: [],
      layout: [],
      isInfoMoal: false,
      infoState: "",
    };
  },
  async mounted() {
    this.isLoadingPage = true;
    this.setLink();
    await this.fetchStartupList();
    await this.fetchTask();
    await this.fetchActivity();
    await this.fetchKpiStartupAll();
    await this.fethCategories();
    setTimeout(() => {
      this.fetchLayout();
    }, 3500);
  },
  watch: {
    resetDashboard() {
      if (this.resetDashboard == true) {
        this.$store.commit("setResetDashboard", false);
        this.resetLayout();
      }
    },
    batch() {
      this.setLink();
    },
  },
  methods: {
    openModalInfo(id) {
      this.$store.commit("setModalActive", true);
      this.infoState = id;
      this.isInfoMoal = true;
    },
    closeModalActive(status) {
      this.$store.commit("setModalActive", status);
    },
    getFundColor(s) {
      const status = Number(s);
      let statusColor = "";

      if (status === 1) {
        statusColor = "#707070";
      } else if (status === 2) {
        statusColor = "#ffa800";
      } else if (status === 3) {
        statusColor = "#707070";
      } else if (status === 4) {
        statusColor = "#ac1818";
      } else if (status === 5) {
        statusColor = "#0ecb81";
      } else {
        statusColor = "-";
      }
      return statusColor;
    },
    getPercentGrowth(last, before) {
      let num = last - before;
      let sum = num / before;
      let percent = sum * 100;
      if (isFinite(percent) === true) {
        return Number(percent.toFixed(2));
      } else {
        return 0;
      }
    },
    fetchKpiStartupAll() {
      this.renderKpi = false;
      for (let index = 0; index < this.startupLists.length; index++) {
        setTimeout(() => {
          this.fetchKpiAll(this.startupLists[index].startUpId);
        }, 500 * index);
      }
      setTimeout(() => {
        this.renderKpi = true;
      }, 3000);
    },
    changTap() {
      this.renderKpi = false;
      setTimeout(() => {
        this.renderKpi = true;
      }, 100);
    },
    fetchKpiAll(id) {
      this.kpi = {};
      let obj = {
        roleId: this.batch._id,
        companyId: id,
      };
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTPDynamic.post(`api/get/all/kpi`, obj)
        .then((res) => {
          //console.log("api/get/all/kpi", res.data.obj);
          if (res.data.success && res.data.obj.length > 0) {
            Object.keys(res.data.obj[res.data.obj.length - 1].kpi).forEach(
              (key) => {
                let count = 1;
                let futureCount = 1;
                let q = 1;
                let repeatDate = new Date(2019, 0, 1);
                let repeatStartNum = repeatDate.getMonth();
                let repeatDateFuture = new Date(
                  res.data.obj[res.data.obj.length - 1].kpi[
                    key
                  ].repeat.repeatStart
                );
                repeatDateFuture = new Date(
                  repeatDateFuture.setMonth(
                    repeatStartNum +
                      res.data.obj[res.data.obj.length - 1].kpi[key].repeat
                        .everyRepeat *
                        futureCount,
                    1
                  )
                );
                let repeatStartNumFuture = repeatDateFuture.getMonth();
                const repeatDateFutureConst = repeatDateFuture;

                this.kpi[key] = {
                  name: res.data.obj[res.data.obj.length - 1].kpi[key]
                    .nameLabel,
                  label: [],
                  value: [],
                };

                while (repeatDate.getTime() <= new Date().getTime()) {
                  if (q > 4) {
                    q = 1;
                  }
                  let updatedAt =
                    res.data.obj[res.data.obj.length - 1].updatedAt;
                  let label =
                    "Q" + q + "(" + new Date(updatedAt).getFullYear() + ")";
                  // let label =
                  //   new Date(repeatDate).getDate() +
                  //   " " +
                  //   this.getMothFormat(new Date(repeatDate).getMonth()) +
                  //   "" +
                  //   new Date(repeatDate)
                  //     .getFullYear()
                  //     .toString()
                  //     .slice(2, 4);
                  this.kpi[key].label.push(label);

                  let value = [];
                  //console.log("sdasdasd", res.data.obj.length);
                  for (let index = 0; index < res.data.obj.length; index++) {
                    if (
                      new Date(
                        res.data.obj[index].kpi[key].lastUpdate
                      ).getTime() >= repeatDate.getTime() &&
                      new Date(
                        res.data.obj[index].kpi[key].lastUpdate
                      ).getTime() < repeatDateFuture.getTime()
                    ) {
                      value.push({
                        data: res.data.obj[index].kpi[key].input,
                        date: new Date(
                          res.data.obj[index].kpi[key].lastUpdate
                        ).getTime(),
                      });
                    }
                  }

                  if (value.length > 0) {
                    let sort = value.sort((a, b) => {
                      const modifier = -1;
                      if (a.date < b.date) return -1 * modifier;
                      if (a.date > b.date) return 1 * modifier;
                      return 0;
                    });
                    this.kpi[key].value.push(
                      sort[0].data !== null ? sort[0].data : null
                    );
                  } else {
                    this.kpi[key].value.push(0);
                  }

                  repeatDate = new Date(
                    res.data.obj[res.data.obj.length - 1].kpi[
                      key
                    ].repeat.repeatStart
                  );
                  repeatDate.setMonth(
                    repeatStartNum +
                      res.data.obj[res.data.obj.length - 1].kpi[key].repeat
                        .everyRepeat *
                        count,
                    1
                  );
                  repeatDateFuture = new Date(
                    res.data.obj[res.data.obj.length - 1].kpi[
                      key
                    ].repeat.repeatStart
                  );
                  repeatDateFuture.setMonth(
                    repeatStartNumFuture +
                      res.data.obj[res.data.obj.length - 1].kpi[key].repeat
                        .everyRepeat *
                        futureCount,
                    1
                  );

                  q++;
                  count++;
                  futureCount++;
                }
              }
            );
            this.kpiAll.push(this.kpi);
          }
          //console.log(this.kpiAll);
        })
        .catch((e) => {
          this.isLoadingPage = false;
          console.log("api/get/all/kpi/error", e);
        });
    },
    getMothFormat(month) {
      let text = "";
      switch (month) {
        case 0:
          text = "Jan'";
          break;
        case 1:
          text = "Feb'";
          break;
        case 2:
          text = "Mar'";
          break;
        case 3:
          text = "Apr'";
          break;
        case 4:
          text = "May'";
          break;
        case 5:
          text = "Jun'";
          break;
        case 6:
          text = "Jul'";
          break;
        case 7:
          text = "Aug'";
          break;
        case 8:
          text = "Sep'";
          break;
        case 9:
          text = "Oct'";
          break;
        case 10:
          text = "Nov'";
          break;
        case 11:
          text = "Dec'";
          break;
        default:
          break;
      }
      return text;
    },
    setLink() {
      this.batch.isSpa ? (this.isSpa = "spa/") : (this.isSpa = "");

      this.staffLink = `${process.env.VUE_APP_BASE_URL}/${this.isSpa}signup/staff/${this.batch._id}`;
      //console.log("this.batch", this.batch);
      this.startupLink = `${process.env.VUE_APP_BASE_URL}/${this.isSpa}signup/startup/${this.batch._id}`;
    },
    copyStaffLink() {
      const copyText = document.getElementById("staff-link");
      copyText.select();
      document.execCommand("copy");
      this.$toast.open({ message: "Copied to clipboard!", type: "is-info" });
    },
    copyStartupLink() {
      const copyText = document.getElementById("startup-link");
      copyText.select();
      document.execCommand("copy");
      this.$toast.open({ message: "Copied to clipboard!", type: "is-primary" });
    },
    async fetchTask() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await this.startupLists.map((item) => {
        HTTP.get(`api/task/batch/${this.batch._id}/startUp/${item.startUpId}`)
          .then((res) => {
            // console.log("api/task/batch/", res);
            if (res.data.success) {
              res.data.obj.task.map((task) => {
                this.tasksAllStartup.push(task);
              });
            }
          })
          .catch((e) => {
            console.log("dashboard staff load Task error", e);
          });
      });
      this.$store.commit("setTaskLength", this.tasksAllStartup.length);
      this.$store.commit("setTasksAll", this.tasksAllStartup);
      this.$store.commit("loadTask", this.tasksAllStartup);
      //console.log("this.tasksAllStartup",this.tasksAllStartup)
    },
    async fetchActivity() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await this.startupLists.map((item) => {
        HTTP.get(
          `api/activity/batch/${this.batch._id}/startUp/${item.startUpId}`
        )
          .then((res) => {
            //console.log('api/activity/batch/${this.batch._id}/startUp/${item.startUpId',res)
            if (res.data.success) {
              res.data.obj.activities.map((activity) => {
                this.activitysAllStartup.push(activity);
              });
            }
          })
          .catch((e) => {
            console.log("dashboard staff load Task error", e);
          });
      });
      this.$store.commit("setActivityAll", this.activitysAllStartup);
      this.$store.commit("loadActivity", this.activitysAllStartup);
      //console.log("this.activitysAllStartup",this.activitysAllStartup)
    },
    async fethCategories() {
      const data = {
        batchId: this.batch._id,
        token: this.token,
      };
      await this.$store.dispatch("setCategorie", data);
    },
    async fetchStartupList() {
      let data = {};
      if (this.getRule == "board" || this.getRule == "exclusiveboard") {
        data = {
          batchId: this.batch._id,
          token: this.token,
          staffId: this.report.adminId,
        };
        //console.log("else 1", data, this.dashBoardrule);
      } else {
        data = {
          batchId: this.batch._id,
          token: this.token,
          staffId:
            this.getRule === "admin" && this.dashBoardrule !== ""
              ? this.staffDetail.staffId
              : this.user._id,
        };
        //console.log("else 2", data, "asdasdas", this.dashBoardrule);
      }

      if (this.getRule === "staff" || this.dashBoardrule !== "") {
        await this.$store.dispatch("setStartupOnStaff", data);
      } else {
        await this.$store.dispatch("setStartuplist", data);
      }
    },
    companyStatus(status) {
      let filter = this.startupLists.filter(
        (item) => item.statusActive === status
      );
      return filter.length;
    },
    getApproveAmountTotal(id, type) {
      let task = [];
      let filterActivity = this.activitysAllStartup.filter(
        (item) => item.categoryId === id
      );
      filterActivity.map((activity) => {
        let filterTask = this.tasksAllStartup.filter(
          (task) =>
            task.activityId === activity._id &&
            task.fundStatus !== null &&
            task.fundStatus !== 0 &&
            task.fundStatus !== 4 &&
            ((type !== "normal" && task.fundStatus !== 1) ||
              (type === "normal" && task.fundStatus === 5))
        );
        filterTask.map((item) => {
          task.push(item);
        });
      });

      let amount = 0;
      task.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== ""
        ) {
          amount = amount + item.approveAmount;
        }
      });
      return amount;
    },
    getPendingRequestTotal(id, type) {
      let task = [];

      let filterActivity = this.activitysAllStartup.filter(
        (item) => item.categoryId === id
      );
      if (this.getRule == "exclusiveboard" && this.batch.cat == 0) {
        filterActivity.map((activity) => {
          let filterTask = this.tasksAllStartup.filter(
            (task) =>
              task.activityId === activity._id &&
              task.fundStatus !== null &&
              task.fundStatus !== 0 &&
              task.fundStatus !== 4 &&
              ((type !== "normal" && task.fundStatus !== 1) ||
                (type === "normal" && task.fundStatus === 2))
          );
          filterTask.map((item) => {
            task.push(item);
          });
        });

        let amount = 0;
        task.map((item) => {
          if (
            item.fundAmount !== null &&
            typeof item.fundAmount !== "undefined" &&
            item.fundAmount !== ""
          ) {
            if (item.fundStatus === 5) {
              if (
                item.approveAmount !== null &&
                typeof item.approveAmount !== "undefined" &&
                item.approveAmount !== ""
              ) {
                amount = amount + item.approveAmount;
              }
            } else {
              amount = amount + item.fundAmount;
            }
          }
        });
        return amount;
      } else {
        filterActivity.map((activity) => {
          let filterTask = this.tasksAllStartup.filter(
            (task) =>
              task.activityId === activity._id &&
              task.fundStatus !== null &&
              task.fundStatus !== 0 &&
              task.fundStatus !== 4 &&
              ((type !== "normal" && task.fundStatus !== 1) ||
                (type === "normal" && task.fundStatus === 2))
          );
          filterTask.map((item) => {
            task.push(item);
          });
        });

        let amount = 0;
        task.map((item) => {
          if (
            item.fundAmount !== null &&
            typeof item.fundAmount !== "undefined" &&
            item.fundAmount !== ""
          ) {
            if (item.fundStatus === 5) {
              if (
                item.approveAmount !== null &&
                typeof item.approveAmount !== "undefined" &&
                item.approveAmount !== ""
              ) {
                amount = amount + item.approveAmount;
              }
            } else {
              amount = amount + item.fundAmount;
            }
          }
        });

        return amount;
      }
    },
    getPercenApprove(amount, total) {
      let resPercent = 0;
      if (amount > total) {
        resPercent = 100;
      } else {
        if (
          amount !== "" &&
          amount !== null &&
          typeof amount !== "undefined" &&
          typeof amount !== "" &&
          total !== "" &&
          total !== null &&
          typeof total !== "undefined" &&
          amount !== 0 &&
          total !== 0
        ) {
          resPercent = Math.round((amount * 100) / total);
        }
      }

      return resPercent;
    },
    getActivityOfCat(id) {
      let res = this.activitysAllStartup.filter(
        (item) => item.categoryId === id
      );
      return res.length;
    },
    updateItemLayout() {
      let itemLayout = [];
      this.layout.map((item) => {
        itemLayout.push({
          x: item.x,
          y: item.y,
          w: item.w,
          h: item.h,
          i: item.i,
          properties: {},
        });
      });

      let obj = {
        batchId: this.batch._id,
        objects: itemLayout,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`api/save/drang/and/drop`, obj)
        .then((res) => {
          this.fetchLayout();
        })
        .catch((e) => {
          console.log("api/save/drang/and/drop/error", e);
        });
    },
    resetLayout() {
      //this.$store.commit('setResetDashboard',false)
      const sizeWindows = [
        //Project overview
        {
          x: 0,
          y: 0,
          w: 6,
          h:
            this.companyStatus(2) +
              this.companyStatus(3) +
              this.companyStatus(1) +
              this.companyStatus(4) +
              this.companyStatus(0) >
            0
              ? 6
              : 3,
          i: "0",
          minW: 6,
          minH: 6,
        },
        //level of business
        {
          x: 0,
          y: 1,
          w: 12,
          h: Math.max(...this.businessLevelBarData) > 0 ? 6 : 3,
          i: "1",
          minW: 6,
          minH: 6,
        },
        //type of business
        {
          x: 0,
          y: 2,
          w: 12,
          h: this.getTypeBussinessH(this.businessType.length, this.widthMax),
          i: "2",
          minW: 6,
          minH: this.getTypeBussinessH(this.businessType.length, this.widthMax),
        },
        //performance
        {
          x: 6,
          y: 0,
          w: 6,
          h: this.tasksAllStartup.length > 0 ? 6 : 3,
          i: "3",
          minW: 6,
          minH: 2,
        },
        //performance support
        {
          x: 0,
          y: 3,
          w: 12,
          h:
            this.categories.length < 5 || this.activitysAllStartup.length == 0
              ? 3
              : this.categories.length <= 6
              ? 4
              : this.categories.length <= 10
              ? 4
              : this.categories.length < 16
              ? 5
              : this.categories.length < 22
              ? 6
              : this.categories.length < 21
              ? 7
              : 8,
          i: "4",
          minW: 12,
          minH: this.categories.length < 10 ? 1 : 1,
        },
        //invest
        // {x:(this.categories.length <= 8 && this.activitysAllStartup.length != 0)?0:
        //   (this.categories.length <= 8 && this.activitysAllStartup.length == 0)?0:
        //   (this.activitysAllStartup.length == 0) ? 0:0,
        // y:2,
        // w:6,
        // h:(this.taskPendingRequest == 0 && this.taskApproveAmount == 0) ? 3 : ((this.taskPendingRequest == 0 && this.taskApproveAmount == 0) || this.categories.length < 10)?6:6,i:"5",
        // minW:6,
        // minH:3},
        //invest support
        {
          x: 0,
          y: 3,
          w: 12,
          h:
            this.categories.length < 5 ||
            (this.taskPendingRequest == 0 && this.taskApproveAmount == 0)
              ? 3
              : this.categories.length < 10
              ? 6
              : this.categories.length < 13
              ? 7
              : this.categories.length < 16
              ? 8
              : this.categories.length < 22
              ? 10
              : 10,
          i: "6",
          minW: 12,
          minH:
            this.categories.length < 10 && this.getRule === "exclusiveboard"
              ? 4
              : this.getRule === "exclusiveboard"
              ? 6
              : this.categories.length < 10 && this.getRule !== "exclusiveboard"
              ? 6
              : 8,
        },

        //business growth
        {
          x:
            this.activitysAllStartup.length == 0
              ? 0
              : this.taskPendingRequest == 0 && this.taskApproveAmount == 0
              ? 6
              : this.categories.length < 13
              ? 6
              : 0,
          y:
            this.categories.length < 13 &&
            this.taskPendingRequest == 0 &&
            this.taskApproveAmount == 0
              ? 4
              : 4,
          w:
            this.taskPendingRequest == 0 && this.taskApproveAmount == 0
              ? 12
              : this.categories.length < 13
              ? 12
              : 12,
          h: typeof this.kpiAllData.Employment === "undefined" ? 3 : 6,
          i: "7",
          minW: 6,
          minH: 3,
        },
      ];

      if (this.dashBoardrule == "") {
        let obj = {
          batchId: this.batch._id,
          objects: sizeWindows,
        };
        HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        HTTP.post(`api/save/drang/and/drop`, obj)
          .then((res) => {
            this.fetchLayout();
          })
          .catch((e) => {
            console.log("api/save/drang/and/drop/error", e);
          });
      } else {
        this.layout = this.widthMax > 768 ? sizeWindows : sizeMobile;
        //console.log("reset",'this.tasksAllStartup.length',this.tasksAllStartup.length,'sizeWindows',sizeWindows,'this.categories.length',this.categories.length,'this.categories.length',this.categories.length)
      }
    },
    async fetchLayout() {
      const sizeWindows = [
        //Project overview
        {
          x: 0,
          y: 0,
          w: 6,
          h:
            this.companyStatus(2) +
              this.companyStatus(3) +
              this.companyStatus(1) +
              this.companyStatus(4) +
              this.companyStatus(0) >
            0
              ? 6
              : 3,
          i: "0",
          minW: 6,
          minH: 6,
        },
        //level of business
        {
          x: 0,
          y: 1,
          w: 12,
          h: Math.max(...this.businessLevelBarData) > 0 ? 6 : 3,
          i: "1",
          minW: 6,
          minH: 6,
        },
        //type of business
        {
          x: 0,
          y: 2,
          w: 12,
          h: this.getTypeBussinessH(this.businessType.length, this.widthMax),
          i: "2",
          minW: 6,
          minH: this.getTypeBussinessH(this.businessType.length, this.widthMax),
        },
        //performance
        {
          x: 6,
          y: 0,
          w: 6,
          h: this.tasksAllStartup.length > 0 ? 6 : 3,
          i: "3",
          minW: 6,
          minH: 2,
        },
        //performance support
        {
          x: 0,
          y: 3,
          w: 12,
          h:
            this.categories.length < 5 || this.activitysAllStartup.length == 0
              ? 3
              : this.categories.length <= 6
              ? 4
              : this.categories.length <= 10
              ? 4
              : this.categories.length < 16
              ? 5
              : this.categories.length < 22
              ? 6
              : this.categories.length < 21
              ? 7
              : 8,
          i: "4",
          minW: 6,
          minH: this.categories.length < 10 ? 1 : 1,
        },
        //invest
        // {x:(this.categories.length <= 8 && this.activitysAllStartup.length != 0)?0:
        //   (this.categories.length <= 8 && this.activitysAllStartup.length == 0)?0:
        //   (this.activitysAllStartup.length == 0) ? 0:0,
        // y:2,
        // w:6,
        // h:(this.taskPendingRequest == 0 && this.taskApproveAmount == 0) ? 3 : ((this.taskPendingRequest == 0 && this.taskApproveAmount == 0) || this.categories.length < 10)?6:6,i:"5",
        // minW:6,
        // minH:3},
        //invest support
        {
          x: 0,
          y: 3,
          w: 12,
          h:
            this.categories.length < 5 ||
            (this.taskPendingRequest == 0 && this.taskApproveAmount == 0)
              ? 3
              : this.categories.length < 10
              ? 6
              : this.categories.length < 13
              ? 7
              : this.categories.length < 16
              ? 8
              : this.categories.length < 22
              ? 10
              : 10,
          i: "6",
          minW: 12,
          minH:
            this.categories.length < 10 && this.getRule === "exclusiveboard"
              ? 4
              : this.getRule === "exclusiveboard"
              ? 6
              : this.categories.length < 10 && this.getRule !== "exclusiveboard"
              ? 6
              : 8,
        },

        //business growth
        {
          x:
            this.activitysAllStartup.length == 0
              ? 0
              : this.taskPendingRequest == 0 && this.taskApproveAmount == 0
              ? 6
              : this.categories.length < 13
              ? 6
              : 0,
          y:
            this.categories.length < 13 &&
            this.taskPendingRequest == 0 &&
            this.taskApproveAmount == 0
              ? 4
              : 4,
          w:
            this.taskPendingRequest == 0 && this.taskApproveAmount == 0
              ? 12
              : this.categories.length < 13
              ? 12
              : 12,
          h: typeof this.kpiAllData.Employment === "undefined" ? 3 : 6,
          i: "7",
          minW: 6,
          minH: 3,
        },
      ];

      const sizeMobile = [
        { x: 0, y: 0, w: 12, h: 6, i: "0" },
        { x: 0, y: 1, w: 12, h: 8, i: "1" },
        {
          x: 0,
          y: 2,
          w: 12,
          h: this.getTypeBussinessH(this.businessType.length, this.widthMax),
          i: "2",
        },
        { x: 0, y: 3, w: 12, h: 9, i: "3" },
        {
          x: 0,
          y: 4,
          w: 12,
          h:
            this.categories.length < 7
              ? 6
              : this.categories.length < 8
              ? 7
              : this.categories.length < 14
              ? 10
              : 12,
          i: "4",
        },
        // {x:0,y:5,w:12,h:5,i:"5"},
        {
          x: 0,
          y: 6,
          w: 12,
          h:
            this.categories.length < 7
              ? 6
              : this.categories.length < 8
              ? 7
              : this.categories.length < 14
              ? 10
              : 13,
          i: "6",
        },
        { x: 0, y: 7, w: 12, h: 6, i: "7" },
      ];

      if (this.dashBoardrule == "") {
        let obj = {
          batchId: this.batch._id,
          userId:
            this.getRule === "admin" && this.dashBoardrule !== ""
              ? this.staffDetail.staffId
              : this.user._id,
        };
        HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        await HTTP.post(`api/get/drag/and/drop`, obj)

          .then((res) => {
            //console.log(`api/get/drag/and/drop`,res)
            if (res.data.success) {
              let itemLayout = [];
              res.data.obj.objects.map((item) => {
                itemLayout.push({
                  x: item.x,
                  y: item.y,
                  w: item.w,
                  h: item.h,
                  i: item.i,
                  minW: this.getMinW(item.i),
                  minH: this.getMinH(item.i),
                });
              });

              this.isLoadingPage = false;
              if (this.getRule === "exclusiveboard") {
                let size = this.widthMax > 768 ? itemLayout : sizeMobile;
                this.layout = size.filter((filter) => filter.i !== "5");
              } else {
                this.layout = this.widthMax > 768 ? itemLayout : sizeMobile;
              }
              //console.log("layout1",this.layout)
            } else {
              if (this.getRule === "exclusiveboard") {
                let size = this.widthMax > 768 ? sizeWindows : sizeMobile;
                this.layout = size.filter((filter) => filter.i !== "5");
              } else {
                this.layout = this.widthMax > 768 ? sizeWindows : sizeMobile;
              }
              this.isLoadingPage = false;
            }
          })
          .catch((e) => {
            console.log("api/get/drag/and/drop/error", e);
          });
      } else {
        this.isLoadingPage = false;
        await this.resetLayout();
      }
    },
    getMinH(i) {
      switch (i) {
        case "0":
          return 6;
        case "1":
          return 6;
        case "2":
          return 3;
        case "3":
          return 6;
        case "4":
          return 6;
        case "5":
          return 6;
        case "6":
          return 6;
        case "7":
          return 6;
        default:
          break;
      }
    },
    getMinW(i) {
      switch (i) {
        case "0":
          return 6;
          break;
        case "1":
          return 6;
          break;
        case "2":
          return 12;
          break;
        case "3":
          return 6;
          break;
        case "4":
          return 6;
          break;
        case "5":
          return 6;
          break;
        case "6":
          return 6;
          break;
        case "7":
          return 12;
          break;
        default:
          break;
      }
    },
    getTypeBussinessH(h, wm) {
      if (h < 6) {
        return wm > 768 ? 3 : 3;
      } else if (h < 9) {
        return wm > 768 ? 4 : 4;
      } else if (h < 12) {
        return wm > 768 ? 5 : 5;
      } else if (h < 15) {
        return wm > 768 ? 6 : 6;
      } else if (h < 18) {
        return wm > 768 ? 7 : 7;
      } else if (h < 21) {
        return wm > 768 ? 8 : 8;
      } else if (h < 24) {
        return wm > 768 ? 9 : 9;
      } else if (h < 27) {
        return wm > 768 ? 10 : 10;
      } else if (h < 30) {
        return wm > 768 ? 11 : 11;
      } else {
        return wm > 768 ? 12 : 12;
      }
    },
    openModalInfo(id) {
      this.$store.commit("setModalActive", true);
      this.infoState = id;
      this.isInfoMoal = true;
    },
    openIsDetailWorkToday(status) {
      this.$store.commit("setModalActive", true);
      this.isDetailWorkToday = true;
    },
    openIsDetailWorkTodaySuccess(status) {
      this.$store.commit("setModalActive", true);
      this.isDetailWorkTodaySuccess = true;
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 0px) {
  .border-right-solid {
    border-right-style: outset;
    border-width: 0px;
    border-color: #d8d8d8;
  }
  .title-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 10px;
  }
  /* #labelX{
    position: relative;
    bottom: 50px;
    left: 40px;
    font-size: 0.5rem;
  } */
  .mg-mobile-link {
    padding: 0px !important;
  }
}
@media screen and (min-width: 768px) {
  .border-right-solid {
    border-right-style: solid;
    border-width: 1.5px;
    border-color: #d8d8d8;
  }
  .title-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 25%;
  }
  /* #labelX{
    position: relative;
    bottom: 50px;
    left: 36px;
    font-size: 0.5rem;
  } */
  .mg-mobile-link {
    padding: 0.75rem !important;
  }
}
@media screen and (min-width: 1281px) {
  .border-right-solid {
    border-right-style: solid;
    border-width: 1.5px;
    border-color: #d8d8d8;
  }
  .title-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 16%;
  }
  /* #labelX{
    position: relative;
    bottom: 50px;
    left: 25px;
    font-size: 0.5rem;
  } */
  .mg-mobile-link {
    padding: 0.75rem !important;
  }
}
.mg-x-less {
  margin: 0 -0.75rem;
}

.overdue-color {
  color: #ac1818;
}

.pending-color {
  color: #c7c7c7;
}
.box-h-max {
  padding: 20px;
  height: 100%;
}
#investmentSubBox {
  padding: 20px 20px 35px 20px;
}
.line-progress {
  background: #c7c7c7;
  height: 2px;
  margin-left: 2px;
  margin-right: 2px;
}
.line-progress-success {
  height: 5px;
  background-color: #6d8df3;
  position: relative;
  top: 3px;
  border-radius: 10px;
}
.line-title-dh {
  border-bottom: 0.5px solid #d8d8d8;
}
#taskToday {
  padding-top: 50px;
  padding-bottom: 20px;
}
.view-detail:hover {
  /* text-decoration: underline; */
  color: #6d8df3 !important;
}
.view-detail {
  color: #7a7a7a;
}
.h-100-per {
  height: 100%;
}
.m-h-300 {
  min-height: 300px;
}

.top-140 {
  top: 140px !important;
}
</style>
